// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2whNj","footer":"ChangeClinic_footer__xRKWn"};